/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { DeleteRemoveDebtorCollectionMutationResponse, DeleteRemoveDebtorCollectionPathParams, DeleteRemoveDebtorCollection401, DeleteRemoveDebtorCollection403 } from "../../models/DeleteRemoveDebtorCollection";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getDeleteRemoveDebtorCollectionUrl({ debtorCode, collectionId }: { debtorCode: DeleteRemoveDebtorCollectionPathParams["debtorCode"]; collectionId: DeleteRemoveDebtorCollectionPathParams["collectionId"] }) {
  const res = { method: 'DELETE', url: `/api/v1/debtors/${debtorCode}/collections/${collectionId}` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/collections/:collectionId}
 */
export async function deleteRemoveDebtorCollection({ debtorCode, collectionId }: { debtorCode: DeleteRemoveDebtorCollectionPathParams["debtorCode"]; collectionId: DeleteRemoveDebtorCollectionPathParams["collectionId"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteRemoveDebtorCollectionMutationResponse, ResponseErrorConfig<DeleteRemoveDebtorCollection401 | DeleteRemoveDebtorCollection403>, unknown>({ method : "DELETE", url : getDeleteRemoveDebtorCollectionUrl({ debtorCode, collectionId }).url.toString(), ... requestConfig })  
  return res.data
}